/**
 * Dökümanlar presenter'i
 */

import { AppState } from '../../modules/state.js';
import { DocumentsService } from './documents.service.js';
import { DOCUMENT_CATEGORY_LABELS, FILE_TYPE_ICONS } from './documents.types.js';

function getDocumentIcon(type: string): string {
    return FILE_TYPE_ICONS[type as keyof typeof FILE_TYPE_ICONS] || '📄';
}

function getCategoryLabel(category: string): string {
    return DOCUMENT_CATEGORY_LABELS[category as keyof typeof DOCUMENT_CATEGORY_LABELS] || category;
}

export function renderResidentDocumentsPresenter(): void {
    const list = document.getElementById('resident-documents-list');
    if (!list) return;

    const categoryFilter = (document.getElementById('resident-document-category-filter') as HTMLSelectElement | null)?.value || 'all';
    let docs = DocumentsService.getPublic();

    if (categoryFilter !== 'all') {
        docs = docs.filter(document => document.category === categoryFilter);
    }

    if (docs.length === 0) {
        list.innerHTML = '<p class="empty-state">Henüz döküman yüklenmemiş</p>';
        return;
    }

    list.innerHTML = docs.map(document => `
        <div class="bill-card glass-card">
            <div class="bill-header">
                <span class="bill-month">${getDocumentIcon(document.fileType)} ${document.title}</span>
                <span class="bill-year">${new Date(document.uploadedAt).toLocaleDateString('tr-TR')}</span>
            </div>
            ${((Date.now() - new Date(document.uploadedAt).getTime()) / 86400000) <= 14 ? '<span class="resident-item-badge">Yeni</span>' : ''}
            <p class="transaction-description">${getCategoryLabel(document.category)} • ${(document.fileSize / 1024 / 1024).toFixed(2)} MB</p>
            <div class="bill-actions">
                <a href="${document.fileUrl}" target="_blank" class="btn btn-secondary btn-sm btn-full document-download-link">⬇️ İndir</a>
            </div>
        </div>
    `).join('');
}

export function renderDocumentsPresenter(): void {
    const list = document.getElementById('documents-list');
    if (!list) return;

    const categoryFilter = (document.getElementById('document-category-filter') as HTMLSelectElement | null)?.value || 'all';
    const searchQuery = (document.getElementById('document-search') as HTMLInputElement | null)?.value || '';

    let documents = AppState.currentUser.role === 'admin'
        ? DocumentsService.getAll()
        : DocumentsService.getPublic();

    if (categoryFilter !== 'all') {
        documents = documents.filter(document => document.category === categoryFilter);
    }

    if (searchQuery.trim()) {
        const query = searchQuery.toLowerCase();
        documents = documents.filter(document =>
            document.title.toLowerCase().includes(query) ||
            (document.description && document.description.toLowerCase().includes(query))
        );
    }

    const stats = DocumentsService.getStats();
    const totalDocs = document.getElementById('total-documents');
    const financialDocs = document.getElementById('financial-documents');
    const legalDocs = document.getElementById('legal-documents');
    if (totalDocs) totalDocs.textContent = String(stats.total);
    if (financialDocs) financialDocs.textContent = String(stats.byCategory.financial || 0);
    if (legalDocs) legalDocs.textContent = String(stats.byCategory.legal || 0);

    if (documents.length === 0) {
        list.innerHTML = '<p class="empty-state">Döküman bulunamadı</p>';
        return;
    }

    list.innerHTML = documents.map(document => `
        <div class="transaction-item document-item">
            <div class="document-item-main">
                <div class="doc-icon">
                    ${getDocumentIcon(document.fileType)}
                </div>
                <div class="document-item-content">
                    <h4>${document.title}</h4>
                    <div class="document-item-meta">
                        ${new Date(document.uploadedAt).toLocaleDateString('tr-TR')} • ${(document.fileSize / 1024 / 1024).toFixed(2)} MB • ${getCategoryLabel(document.category)}
                    </div>
                    ${document.description ? `<div class="document-item-description">${document.description}</div>` : ''}
                </div>
            </div>
            <div class="doc-actions">
                <a href="${document.fileUrl}" target="_blank" rel="noopener noreferrer" class="btn btn-sm btn-secondary document-download-link">
                    👁 Önizle
                </a>
                <a href="${document.fileUrl}" target="_blank" rel="noopener noreferrer" class="btn btn-sm btn-secondary document-download-link">
                    ⬇️ İndir
                </a>
                ${AppState.currentUser.role === 'admin' ? `
                <button class="btn btn-sm btn-danger delete-doc-btn" data-id="${document.id}">
                    🗑️
                </button>
                ` : ''}
            </div>
        </div>
    `).join('');
}
